"use client";

import dynamic from "next/dynamic";
import Footer from "@/components/layout/Footer";

// Lazy-load non-critical overlay components (not visible above the fold, deferred rendering)
// Footer is imported normally to avoid CLS (layout shift)
const PWAPrompt = dynamic(() => import("@/components/pwa/PWAPrompt"), {
  ssr: false,
});
const CookieConsent = dynamic(() => import("@/components/legal/CookieConsent"), {
  ssr: false,
});

export function DeferredComponents() {
  return (
    <>
      <Footer />
      <PWAPrompt />
      <CookieConsent />
    </>
  );
}
